<template>
  <div>
    <el-row>
      <el-col :span="3">
        <el-select v-model="params.code" placeholder="请选择监控类型">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5" :offset="1">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
            v-model="dateBetween"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="3" :offset="1">
        <el-button type="primary" style="margin-left:10px;" @click="search">检索</el-button>        
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10">
        <div
          id="main"
          style="width: 100%; height: 400px; margin-top: 10px"
        ></div
      ></el-col>
    </el-row>
  </div>
</template>

<script>
import MonitorLogApi from "@/api/MonitorLogApi";
export default {
  name: "NginxAnalysis",
  data() {
    return {
        options: [
        {
          value: "SERVER_MONITOR_MEMBER_CENTER_ID_CARD_VALIDATE_VALIDATE",
          label: "经营帮实名认证",
        },
        {
          value: "SERVER_MONITOR_ENTERPRISE_MANAGERMENT_ID_CARD_VALIDATE_VALIDATE",
          label: "企管帮实名认证",
        },
        // {
        //   value: "SERVER_MONITOR_AUTHENTICATION_USERLOGIN_LOGIN",
        //   label: "系统登录成功",
        // },
        // {
        //   value: "SERVER_MONITOR_MEMBER_CENTER_COMMON",
        //   label: "个人中心通相关",
        // },
      ],
      params:{
        code:"SERVER_MONITOR_MEMBER_CENTER_ID_CARD_VALIDATE_VALIDATE",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dateBetween: [],
    };
  },
  mounted() {
    let date = new Date();
    let defalutStartTime = date.getTime() - 7 * 24 * 3600 * 1000; // 转化为时间戳
    let startDateNs = new Date(defalutStartTime);
    this.dateBetween = [startDateNs, date];
    this.params.startTime =startDateNs;
    this.params.endTime = date;
    this.queryAlerm()
  },
  methods: {
    queryAlerm(){
        this.params.startTime =this.dateBetween[0];
        this.params.endTime = this.dateBetween[1];
        MonitorLogApi.alertCount(this.params).then(resp=>{
            if(resp.state=='OK'){
                let dataLend = resp.data.dataLend;
                let data = resp.data.data;
                this.initIdCardValidate(dataLend,data);
            }
        })
    },
    initIdCardValidate(dataLend,data) {
      var chartDom = document.getElementById("main");
      var myChart = this.$echarts.init(chartDom);
      var option= {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: dataLend,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "数量",
            type: "bar",
            barWidth: "60%",
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },

    search(){
        this.queryAlerm()
    }
  },
};
</script>